import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./permissao-listar/permissao-listar.module').then(m => m.PermissaoListarModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./permissao-editar/permissao-editar.module').then(m => m.PermissaoEditarModule) },
        { path: 'inserir', data: { breadcrumb : 'Inserir' }, loadChildren: () => import('./permissao-inserir/permissao-inserir.module').then(m => m.PermissaoInserirModule) }
    ])],
    exports: [RouterModule]
})
export class PermissaoAppRoutingModule { }